/**
 * Social-provider discovery (SignIn): the build-time VITE_SOCIAL_PROVIDERS list
 * unioned with GET /api/auth-providers at runtime. Pure — see providers.test.ts.
 */

/** Union of provider ids, build-time entries first, deduped, normalized to lowercase. */
export function mergeProviders(buildTime: string[], runtime: string[]): string[] {
  const out: string[] = [];
  for (const raw of [...buildTime, ...runtime]) {
    const id = raw.trim().toLowerCase();
    if (id && !out.includes(id)) out.push(id);
  }
  return out;
}
